/** App chrome and access-gate copy (NAV, work-email gate, access denied, blocked entity). Part of `UI_STRINGS` - see ui-strings.ts. */
export const UI_SHELL_STRINGS = {
  NAV: {
    SIGN_IN: 'Log In',
    GET_STARTED: 'Sign Up Free',
    CREATE_STARTUP: 'Create Startup Profile',
    RESUME_STARTUP: 'Resume Startup Profile',
    CANCEL_STARTUP: 'Cancel Startup',
    /** FR-205: replaces Cancel Startup while the Issue Report journey is in progress. */
    BACK_TO_DUE_DILIGENCE: 'Back to Due Diligence page',
    /** Replaced every "Upgrade to Premium" in v1.2 (FR-128). Startup Admins only. */
    GET_ISSUE_REPORT: 'Get an Issue Report',
    LOG_OUT: 'Log Out',
    NETWORK: 'Network',
    WORKSPACE: 'Workspace',
    DATA_ROOM: 'DATA Room',
    /** Top-level, not a Workspace child - see `buildNavItems` (FR-41). */
    BILLING: 'Billing & Info',
    ADMIN: 'Admin',
    INDIVIDUAL_PROFILE: 'Individual Profile',
    STARTUP_PROFILE: 'Startup Profile',
    STARTUP_TEAM_PERMISSIONS: 'Team Access',
    INVESTOR_PROFILE: 'Investor Profile',
    INVESTOR_TEAM_PERMISSIONS: 'Team Access',
  },
  WORK_EMAIL_GATE: {
    TITLE: 'A company email is required',
    DESCRIPTION:
      "Creating a startup profile requires a company email - we couldn't verify that this account uses one. Personal and temporary email providers aren't supported.",
    ACTION: 'Change Email',
  },
  ACCESS_DENIED: {
    TITLE: 'Access denied',
    DESCRIPTION: "You don't have permission to view this page.",
    ACTION: 'Go to Dashboard',
  },
  /**
   * Member-facing states for a startup an admin has suspended or deleted
   * (MYN-131 AC-4). Two distinct states, not one generic denial: suspension
   * reads as temporary and recoverable, deletion as permanent. The member's
   * session stays valid either way - only startup-scoped surfaces (this
   * profile page) are blocked, so the copy never suggests logging out or
   * signing back in.
   */
  ENTITY_BLOCKED: {
    SUSPENDED_TITLE: 'Startup profile suspended',
    SUSPENDED_DESCRIPTION:
      "An administrator has temporarily suspended this startup's profile. Your account is unaffected - you can still sign in and use the rest of My NEXT Raise.",
    DELETED_TITLE: 'Startup profile closed',
    DELETED_DESCRIPTION:
      "An administrator has permanently closed this startup's profile. It cannot be reopened from here.",
    CONTACT_SUPPORT: 'If you believe this is a mistake, contact My NEXT Raise support for help.',
    ACTION: 'Go to Dashboard',
  },
  /** View as user tab (MYN-335, FR-241): the banner on every screen and the ended page. */
  VIEW_AS: {
    BANNER: (email: string) => `You are viewing as ${email}. View only: nothing can be changed.`,
    BANNER_BY: (adminName: string, endsAt: string) => `Opened by ${adminName}. Ends ${endsAt}.`,
    EXIT: 'Exit',
    EXITING: 'Exiting...',
    EXIT_FAILED_FALLBACK: 'Could not end this session. Try again.',
    ENDED_TITLE: 'This view-as session has ended',
    ENDED_DESCRIPTION: 'You can close this tab. Your admin console is still open in its own tab.',
    CLOSE_TAB: 'Close tab',
  },
} as const;
